import { render, staticRenderFns } from "./PedidosBossNegocioTiempoReal.vue?vue&type=template&id=9e8d1e9e&"
import script from "./PedidosBossNegocioTiempoReal.vue?vue&type=script&lang=js&"
export * from "./PedidosBossNegocioTiempoReal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VSpacer,VSystemBar})
